<template>
  <div class="ecSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="3">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="3">
        <Select
          v-model="accountType"
          filterable
          :placeholder="$t('alarms.common.filterByAccountType')"
          :transfer="true"
        >
          <Option value="" selected>{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.id"
            v-for="item in accountTypeList"
            :key="item.name"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <!-- todo 区域暂时先取消掉
            <Col span="3">
                <Select v-model="region" filterable placeholder="按区域筛选"  @on-change="searchRegion(region)" :transfer="true">
                    <Option value="" selected>{{ $t('alarms.common.allRegion') }}</Option>
                    <Option :value="item.name" v-for="item in regionList" :key="item.name">{{item.name}}</Option>
                </Select>
            </Col>
            -->
      <Col span="3">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="accountName"
          :placeholder="$t('alarms.common.filterByAccountName')"
        />
      </Col>
      <Col span="3">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="instanceId"
          :placeholder="$t('alarms.common.filterByInstanceId')"
        />
      </Col>
      <Col span="3">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="instanceName"
          :placeholder="$t('alarms.common.filterByInstanceName')"
        />
      </Col>
      <Col span="3">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="privateIp"
          :placeholder="$t('alarms.common.filterByIpAddress')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['monitor:elasticComputeCloudMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
        <Button
          type="warning"
          :loading="modal_loading"
          @click="exportStatisticsList"
          v-hasPermission="['monitor:elasticComputeCloudMonitor:export']"
          >{{ $t("common.exportStatistics") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
export default {
  name: "ElasticComputeCloudMonitorSearch",
  // 接受父组件的值
  props: {
    ecColumns: Array
  },
  data() {
    return {
      modal_loading: false,
      tag: "",
      region: [],
      instanceId: "",
      regionList: [],
      regionName: "",
      privateIp: "",
      instanceName: "",
      accountName: "",
      accountType: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountTypeList: [
        {
          id: 0,
          name: "AWS"
        },
        {
          id: 1,
          name: "Aliyun"
        },
        {
          id: 2,
          name: "Azure"
        },
        {
          id: 3,
          name: "VMware"
        },
        {
          id: 4,
          name: "GCP"
        }
      ]
    };
  },
  mounted: function() {
    this.getQueryRegions();
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountType", this.accountType);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("instanceId", this.instanceId);
      eventBus.$emit("instanceName", this.instanceName);
      eventBus.$emit("privateIp", this.privateIp);
      eventBus.$emit("tag", this.tag);
      this.$parent.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    //查询地区
    getQueryRegions: function() {
      this.$api.account
        .queryRegions("userName", getCookie(global.cookieName))
        .then(res => {
          this.regionList = res.data;
        });
    },
    // 按区域筛选
    searchRegion: function() {
      eventBus.$emit("region", this.region);
    },
    //导出统计
    exportStatisticsList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });

      // 下载Excel 文件
      this.$api.resourceManagement
        .exportInstanceStatistics({
          companyId: this.companyId,
          accountType: this.accountType,
          accountName: this.accountName,
          instanceId: this.instanceId,
          instanceName: this.instanceName,
          privateIp: this.privateIp,
          tag: this.tag,
          // "region":  this.region,
          monitorModule: 0,
          // 动态表头
          title: this.ecColumns
        })
        .then(res => {
          let fileName = "实例使用统计情况.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>
<style scoped>
.ecSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/ec2/ElasticComputeCloudMonitorSearch.vue